import React, { Component, useState, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import Amplify, { Auth } from "aws-amplify";
import awsconfig from "../../aws-exports";
import Logo from "../../assets/img/nbrri-logo.png";
import { Context } from "../../Store.js";
import "./header.styles.css";

Amplify.configure(awsconfig);

const Header = () => {
  const history = useHistory();
  const [openNav, setOpenNav] = React.useState("hidden");
  const [state, dispatch] = useContext(Context);

  const logout = async () => {
    try {
      await Auth.signOut();
      dispatch({ type: "SET_LOGGED_IN_USER", payload: {} });
      dispatch({ type: "SET_IS_LOGGED_IN", payload: false });
      history.push("/login");
    } catch (error) {
      console.log("error signing out: ", error);
    }
  };

  const handleHamburger = async () => {
    openNav === "hidden" ? setOpenNav("show") : setOpenNav("hidden");
  };

  return (
    <React.Fragment>
      <header id="header" className="fixed-top">
        <div className="container d-flex align-items-center">
          <div className="logo me-auto">
            <h1 className="text-light">
              <Link to="/">
                <span>
                  <img src={Logo} />
                </span>
              </Link>
            </h1>
          </div>
          <div className="row">
            {!state.isLoggedIn ? (
              <React.Fragment>
                <Link to="/login" className="btn-login">
                  Login
                </Link>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div className="row">
                  <div className={`light-theme dropdown-fill`}>
                    <nav className="nav-menu d-none d-lg-block">
                      <ul>
                        <li className="active">
                          <Link to="/new-project">New</Link>
                        </li>
                        <li className="active">
                          <Link to="/search">Search</Link>
                        </li>
                        <li className="active">
                          <Link to="/search-archives">Archives</Link>
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <div>
                    <button
                      type="submit"
                      className="btn-sign-up"
                      onClick={logout}
                    >
                      Log out
                    </button>
                  </div>
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
